import { z } from 'zod';
import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { ApplicationsIdSchema } from '../applications.schema';
import {
  AssetMergeAcceptedSchema,
  ForceFinishMergeBodySchema,
  ListAssetMergeHistoryBodySchema,
  ListAssetMergeHistoryResultSchema,
  ListAwaitingMergesBodySchema,
  ListAwaitingMergesResultSchema,
  MergeAssetsPublicBodySchema,
  RevertAssetMergeBodySchema,
  StartAssetMergeDetectBodySchema,
  StartAssetMergeDetectResultSchema,
} from './asset-merge.schema';

export const assetMergeContractRoutes = {
  mergeAssets: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'POST',
      path: '/{id}/assets/merge',
      summary: 'Merge assets',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        body: MergeAssetsPublicBodySchema,
      }),
    )
    .output(AssetMergeAcceptedSchema),
  forceFinishMerge: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'POST',
      path: '/{id}/assets/merge/force-finish',
      summary: 'Force-finish awaiting asset merges',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        body: ForceFinishMergeBodySchema,
      }),
    )
    .output(AssetMergeAcceptedSchema),
  listAwaitingMerges: terraContract
    .meta({
      permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
    })
    .route({
      method: 'POST',
      path: '/{id}/assets/merge/awaiting',
      summary: 'List awaiting asset merges',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        body: ListAwaitingMergesBodySchema,
      }),
    )
    .output(ListAwaitingMergesResultSchema),
  listAssetMergeHistory: terraContract
    .meta({
      permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
    })
    .route({
      method: 'POST',
      path: '/{id}/assets/merge/history',
      summary: 'List asset merge history',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        body: ListAssetMergeHistoryBodySchema,
      }),
    )
    .output(ListAssetMergeHistoryResultSchema),
  revertAssetMerge: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'POST',
      path: '/{id}/assets/merge/revert',
      summary: 'Revert asset merges',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        body: RevertAssetMergeBodySchema,
      }),
    )
    .output(AssetMergeAcceptedSchema),
  startAssetMergeDetect: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'POST',
      path: '/{id}/assets/merge/detect',
      summary: 'Start a full asset-merge detect run',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        body: StartAssetMergeDetectBodySchema,
      }),
    )
    .output(StartAssetMergeDetectResultSchema),
};
